'use client'
import * as React from 'react'
import {
  IntercomProps,
  IntercomProvider as Provider,
  useIntercom,
} from 'react-use-intercom'
import { useUserStore } from '~/app/_store/user-store'
import { makeFullNameFromClerkUser } from '@basehub/data/auth/utils/make-full-name-from-clerk-user'

export const IntercomProvider = ({
  children,
  appId,
  initializeDelay,
  intercomProps,
}: {
  children?: React.ReactNode
  appId: string | null
  initializeDelay?: number
  intercomProps?: IntercomProps | undefined
}) => {
  if (!appId) return children
  return (
    <Provider appId={appId} initializeDelay={initializeDelay}>
      <IntercomBooter {...intercomProps} />
      {children}
    </Provider>
  )
}

function IntercomBooter(props?: IntercomProps | undefined) {
  const { boot, show } = useIntercom()
  const optimisticUser = useUserStore((s) => s.optimisticUser)

  React.useEffect(() => {
    if (optimisticUser) {
      try {
        boot({
          ...props,
          name: makeFullNameFromClerkUser(optimisticUser),
          email: optimisticUser.email ?? '',
          avatar: {
            type: 'avatar',
            imageUrl: optimisticUser.imageUrl ?? '',
          },
          userId: optimisticUser.id,
        })
      } catch {
        console.error("Couldn't parse intercom user cookie")
        boot(props)
      }
    } else {
      boot(props)
    }
  }, [boot, optimisticUser, props])

  React.useEffect(() => {
    const isChatEnabled = new URLSearchParams(window.location.search).get(
      'chat'
    )
    if (isChatEnabled !== null) {
      show()
    }
  }, [show])

  return null
}
